<script setup>
import TD from "@/Components/Table/Element.vue";
import SettingsLayout from "@/Layouts/Settings.vue";
import Input from "@/Components/Settings/Input.vue";
import Label from "@/Components/Settings/Label.vue";
import Button from "@/Components/Button.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import Heading from "@/Components/Settings/Heading.vue";

import { Link, Head, useForm } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";
const page_name = "Sondertermine";

const canEdit = Inertia.page.props.auth.can["edit settings"];
const canDelete = Inertia.page.props.auth.can["delete settings"];

const props = defineProps({
  errors: Object,
  specialDates: Object,
});

const form = useForm({});

function repeatString(value) {
  switch (value) {
    case "once":
      return "Einmalig";
    case "daily":
      return "Täglich";
    case "weekly":
      return "Wöchentlich";
    case "monthly":
      return "Monatlich";
  }
}

function deleteAppointment(id) {
  Inertia.delete(
    `/specialAppointments/${id}`,
    {},
    { preserveState: true, replace: true }
  );
}
</script>

<template>
  <SettingsLayout>
    <!-- <Head title="Stammdaten - Grundeinstellungen" /> -->
    <Head :title="`${page_name} - Grundeinstellungen`" />

    <template #breadcrumb>{{ page_name }}</template>
    <template #controls>
      <HeaderLink href="/" type="close">Schließen</HeaderLink>
    </template>
    <Heading title="Sondertermine" />

    <p class="max-w-2xl text-sm text-oteoText mb-9">
        Sie können Sondertermine wie beispielsweise Teambesprechungen oder Schulungen anlegen, bei Bedarf auch
        als Termin-Wiederholung. In der Kalenderansicht Ihrer Behandler werden die Sondertermine grau dargestellt.
        Bitte beachten Sie, dass die Sondertermine personenbezogen sind und daher nicht bei den Räumen sichtbar sind.
        oteo ist so voreingestellt, dass ein Sondertermin mit einem Patiententermin überschrieben werden kann.
    </p>

    <Button
      v-if="canEdit"
      href="/einstellungen/sondertermine/erstellen"
      class="mb-9"
    >
      Neuen Sondertermin anlegen
    </Button>

    <div class="flex flex-col">
      <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 inline-block min-w-full sm:px-6 lg:px-8">
          <div class="overflow-hidden">
            <table class="min-w-full">
              <thead class="bg-white border-b">
                <tr>
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Terminbezeichnung
                  </th>
                  <!-- <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Wochentag
                  </th> -->
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Zeit
                  </th>
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Wiederholung
                  </th>
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Serienbeginn
                  </th>
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Aktion
                  </th>
                </tr>
              </thead>
              <tbody>
                <!-- <tr
                  v-for="(vac, index) in vacations"
                  :key="vac.id"
                  class="border-b"
                  :class="{ 'bg-gray-100': index % 2 === 0 }"
                >
                  <TD>{{ vac.startString }}</TD>
                  <TD>{{ vac.endString }}</TD>
                  <TD>{{ vac.annotation }}</TD>
                  <TD> </TD>
                </tr> -->

                <tr
                  v-for="(specialDate, index) in specialDates"
                  :key="specialDate.id"
                  class="border-b"
                  :class="{ 'bg-gray-100': index % 2 === 0 }"
                >
                  <TD>{{ specialDate.name }}</TD>
                  <!-- <TD>Wochentag macht kein sinn bei daily</TD> -->
                  <TD>{{ specialDate.timeString }}</TD>
                  <TD>{{ repeatString(specialDate.repetition) }}</TD>
                  <TD>{{ specialDate.dateString }}</TD>
                  <TD>
                    <div v-if="canEdit" class="flex items-center text-oteo-300">
                      <Link
                        class="mr-4"
                        :href="`sondertermine/${specialDate.id}/bearbeiten/`"
                      >
                        <i class="las la-angle-right"></i>bearbeiten
                      </Link>
                      <div
                        v-if="canDelete"
                        class="cursor-pointer"
                        @click="deleteAppointment(specialDate.id)"
                      >
                        <i class="las la-times"></i>
                        löschen
                      </div>
                    </div>
                  </TD>
                </tr>
                <tr>
                  <TD></TD>
                  <TD></TD>
                  <TD></TD>
                  <TD></TD>
                  <TD></TD>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </SettingsLayout>
</template>

